import {FC, memo} from "react";
import {ComplectationsGroupProps} from "./ComplectationsGroup-types";
import ComplectationsSection from "../ComplectationsSection/ComplectationsSection";
import {generateUid} from "../../utils/ApplicationUtils";

/**
 * Глобальная группа элементов
 * Например: Основа / Мешок / Ремень
 *
 * В каждой из групп есть один или несколько атрибутов
 */
const ComplectationsGroup: FC<ComplectationsGroupProps> = memo((props) => {
    const {uid, block, onOptionSelect, isVisibleOnMobile} = props;

    const attributes = block.attributes.filter(attribute => !attribute.isHidden);

    return (
        <>
            {
                attributes.map(attribute => {
                    const currentUid = generateUid(uid, attribute.id);

                    return (
                        <ComplectationsSection
                            key={currentUid}
                            uid={currentUid}
                            isVisibleOnMobile={isVisibleOnMobile}
                            block={block}
                            onOptionSelect={onOptionSelect}
                            attribute={attribute}/>
                    )
                })
            }
        </>
    );
});

export default ComplectationsGroup;
